<template>
    <input
        :id="id"
        v-model.number="_val"
        :v-validate="{decimal:2,required:true, min_value:-100000000, max_value:100000000}"
        :class="cls"
    />
</template>

<script>
    export default {
        name: 'CurrencyInput',
        props: [
            'val',
            'id',
            'vvalidate',
            'datavvscope',
            'name',
            'datavvas',
            'cls'
        ],
        data: function () {
            return {
            };
        },
        model: {
            prop: "val",
            event: "input"
        },
        methods: {
        },
        computed: {
            _val: {
                get: function () { return this.val/100; },
                set: function (v) { this.$emit("input", isNaN(v)?0:Math.round(v*100));  }
            }
        }
    }
</script>
